<template>
  <div @click="agree()">
    <font-awesome-icon
      :icon="icon"
      />
    <span>
      {{ $l.termsAndConditionsAgreement }}
    </span>
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],

  computed: {
    agreed: function () {
      return this.$store.state.register.tosAgreed
    },

    icon: function () {
      if (this.agreed) {
        return 'check-square'
      }
      return 'square'
    }
  },

  methods: {
    agree: function () {
      this.$store.commit('register/setToaAgreed', !this.agreed)
    }
  }
}
</script>
